// extracted by mini-css-extract-plugin
export default {"container":"b6gJjE7_","pdfViewer":"VgxPaOg5"};